/* eslint-disable jsx-a11y/anchor-has-content */
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setContactActive, setContactStatusActive } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { UserStatusType } from "../../../../../Types/MessengerType";
import { dynamicImage, Image } from "../../../../../Utils";

const UserStatus: React.FC<UserStatusType> = ({ item }) => {
  const { selected } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();

  return (
    <div className={`status-content ${item.active ? "active" : ""}`}>
      <ul>
        <li className="user-status">
          <a className="lightbox img-status status" href={`#status-${item.id}`} onClick={() => dispatch(setContactActive(item.id))}>
            <Image className="img-fluid bg-img" src={dynamicImage(`status-img/small/sm-${item.image}.jpg`)} alt="status" />
          </a>
          <div className="lightbox-target" id={`status-${item.id}`}>
            <Image src={dynamicImage(`status-img/large/lg-${selected}.jpg`)} alt="status" />
            <a className="lightbox-close" href={Href} onClick={() => dispatch(setContactStatusActive(item.id))}/>
          </div>
        </li>
        <li>
          <h4>{item.title}</h4>
          <h5>{item.time}</h5>
        </li>
      </ul>
    </div>
  );
};

export default UserStatus;
